<template>
    <div class="page-about">
        <slot name="mantel"></slot>

        <article class="container">
            <p v-if="chapo !== null" class="page-about__chapo" v-html="chapo"></p>

            <h1 v-if="firstSectionTitle !==null"
                class="page-about__section-title"
                v-html="firstSectionTitle"
            ></h1>

            <div class="page-about__stat-container">
                <div class="page-about__stat page-about__stat--1">
                    <slot name="stat-1"></slot>
                </div>

                <div class="page-about__stat page-about__stat--2">
                    <slot name="stat-2"></slot>
                </div>

                <div class="page-about__stat page-about__stat--3">
                    <slot name="stat-3"></slot>
                </div>

                <div class="page-about__stat page-about__stat--4">
                    <slot name="stat-4"></slot>
                </div>

                <div class="page-about__stat page-about__stat--5">
                    <slot name="stat-5"></slot>
                </div>

                <div class="page-about__stat page-about__stat--hero">
                    <slot name="stat-hero"></slot>
                </div>
            </div>
        </article>

        <aside class="container page-about__timeline">
            <h1 v-if="secondSectionTitle !==null"
                class="page-about__section-title"
                v-html="secondSectionTitle"
            ></h1>

            <slot name="timeline"></slot>
        </aside>
    </div>
</template>

<script>
    export default {
        name: 'About',

        props: {
            chapo:              { type: String, default: null },
            firstSectionTitle:  { type: String, default: null },
            secondSectionTitle: { type: String, default: null },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';

    .page-about {
        $grid-gutter: 3rem;

        padding-bottom: 14rem;

        @include media-breakpoint-down (md) {
            padding-bottom: 5rem;
        }

        &__chapo{
            margin: 3.9rem 0 2.1rem;
        }

        &__section-title {
            margin: 3.9rem 0 2.1rem;

            font-size: 2.4rem;

            @include media-breakpoint-down (md) {
                font-size: 2rem;
            }

            ::v-deep * {
                margin: 0 !important;
            }
        }

        &__stat-container {
            display: -ms-grid;
            display: grid;
            grid-template-columns: 1fr $grid-gutter 1fr $grid-gutter 1fr;
            -ms-grid-columns: 1fr $grid-gutter 1fr $grid-gutter 1fr;
            grid-template-rows: auto $grid-gutter auto $grid-gutter auto;
            -ms-grid-rows: auto $grid-gutter auto $grid-gutter auto;

            @include media-breakpoint-down (xs) {
                display: flex;
                flex-direction: column;
            }
        }

        &__stat {
            @include media-breakpoint-down (xs) {
                & + & {
                    margin-top: 2rem;
                }
            }

            &--1 {
                grid-column: 1;
                grid-row: 1;
                -ms-grid-column: 1;
                -ms-grid-row: 1;
            }

            &--2 {
                grid-column: 3;
                grid-row: 1;
                -ms-grid-column: 3;
                -ms-grid-row: 1;
            }

            &--3 {
                grid-column: 5;
                grid-row: 1;
                -ms-grid-column: 5;
                -ms-grid-row: 1;
            }

            &--4 {
                grid-column: 1;
                grid-row: 3;
                -ms-grid-column: 1;
                -ms-grid-row: 3;
            }

            &--5 {
                grid-column: 1;
                grid-row: 5;
                -ms-grid-column: 1;
                -ms-grid-row: 5;
            }

            &--hero {
                grid-column: 3 / 6;
                grid-row: 3 / 6;

                -ms-grid-column: 3;
                -ms-grid-column-span: 3;
                -ms-grid-row: 3;
                -ms-grid-row-span: 3;
            }
        }

        &__timeline-image {
            max-width: 100%;
        }
    }
</style>
